const angular = require('angular');
const ngIdle = require('ng-idle');
const angularSanitize = require('angular-sanitize');
const uirouter = require('@uirouter/angularjs');
const uiBootstrap = require('angular-ui-bootstrap');
const uiSelect = require('ui-select');
const coreModule = require('gw-um-core/coreModule.js');
const j2js = require('gw-um-j2js/j2jsModule.js');

/*@ngInject*/
angular.module('gw-um-auth', [
    angularSanitize,
    ngIdle,
    uirouter.default,
    uiBootstrap,
    uiSelect,
    coreModule,
    j2js
])
    .config(function ($stateProvider) {

        $stateProvider
            .state('login', {
                url: '/login',
                views: {
                    'content': {
                        templateUrl: '/login/login.tpl.html',
                        controller: 'loginController'
                    }
                },
                params: {
                    username: null,
                    login: null,
                    externalToken: null
                },
                data: {
                    noAuth: true
                }
            })
            .state('password', {
                url: '/password',
                views: {
                    'content': {
                        templateUrl: '/changePassword/changePassword.tpl.html',
                        controller: 'changePasswordController'
                    }
                },
                params: {
                    username: null,
                    oldPassword: null,
                    messageKey: null
                },
                data: {
                    noAuth: true
                }
            });
    })
    .run(function ($rootScope, coreMediator, coreConstant) {
        $rootScope.$on('$stateChangeStart', function (event, toState) {
            // On a state change, check to see if the route requires authentication. If it does, check that we are auth'ed,
            // and if we aren't broadcast an INVALID_SESSION event to take care of it (and also block the state change event).
            if (!toState.data || !toState.data.noAuth) {
                if (_.isNil(coreMediator.getLoginToken())) {
                    event.preventDefault();
                    $rootScope.$broadcast(coreConstant.event.INVALID_SESSION);
                }
            }
        });
    });

require('./authenticationMediator');
require('./authenticationUtil');
require('./authorizationRequestInterceptor');
require('./refreshLoginTokenUtil');
require('./repository/changePasswordRepository');
require('./repository/changePasswordWithTokenRepository');
require('./repository/checkAuthRepository');
require('./repository/clientIdRepository');
require('./repository/loginTokenRepository');
require('./repository/refreshLoginTokenRepository');
require('./repository/temporaryLoginTokenRepository');

require('./login/login.less');
require('./login/login.tpl.html');
require('./login/loginController');

require('./login/forgotPassword/forgotPassword.less');
require('./login/forgotPassword/forgotPassword.tpl.html');
require('./login/forgotPassword/forgotPasswordController');
require('./login/forgotPassword/forgotPasswordRepository');

require('./login/repository/loginRepository');

require('./changePassword/changePassword.less');
require('./changePassword/changePassword.tpl.html');
require('./changePassword/changePasswordController');

require('./changePasswordModal/changePasswordModal.less');
require('./changePasswordModal/changePasswordModal.tpl.html');
require('./changePasswordModal/changePasswordModalController');

module.exports = 'gw-um-auth';
